import React from "react"

import DownloadLink from "./download-link"

const ServerErrorScreen = () => {
  return (
    <div className="flex h-screen w-full flex-col px-8 pb-8 pt-32">
      <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Lo sentimos, sucedio un error en el processo.</h1>
      <p className="mb-8 text-ui-fg-base">Descarga la app de Nelo para completar tu compra</p>
      <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-nelo-blue via-blue-200 via-blue-300 via-blue-400 to-nelo-blue p-8 shadow-lg">
        <div className="relative z-10">
          <div className="flex justify-center px-4">
            <DownloadLink />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ServerErrorScreen
